import MaskedInput from './MaskedInput.js';

export default MaskedInput;
